module.exports = __webpack_public_path__ + "static/media/star-rb.7259c2bd.png";